import React from "react";
import "./styles/TestBed.scss";
import TitleFormat from "../components/TitleFormat";
import SaaSTestBedOverView from "../components/SaaSTestBedOverView";
// import SaaSSpaceInfo from "../components/SaaSSpaceInfo";
import { useTranslation } from "react-i18next";
import { Seo } from "../components/Seo";
const TestBed = () => {
  const { t } = useTranslation();
  const title = { text: t("digitalTwin.testBed.title"), path: "" };
  return (
    <>
      <Seo title={`${t("digitalTwin.testBed.seo.title")}`} description={`${t("digitalTwin.testBed.seo.des")}`} path="digital-transformation/testbed" />
      <div className="test_bed_wrap">
        <TitleFormat text={title.text} />
        <SaaSTestBedOverView />
        {/* <SaaSSpaceInfo /> */}
      </div>
    </>
  );
};

export default TestBed;
